import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { ReactComponent as RedTick } from "../../../assets/svgs/redTick.svg";
import { ReactComponent as RedBg } from "../../../assets/svgs/redBg.svg";
import { deleteRegistry } from "../../../utils/api/deleteRegistry";
import toast from "react-hot-toast";

const DeleteRegistryConfirmation = ({ open, onCancel, registryDetail, onOk }) => {
  const handleOnDelete = async () => {
    const id = registryDetail._id;
    const registryID = registryDetail.ID;
    try {
      await deleteRegistry(id, registryID);
      toast.success("Registry Deleted Successfully");
    } catch (error) {
      toast.error("Registry not deleted");
    }
    onOk();
  };
  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={400}>
        <div className="relative">
          <div className="flex justify-center items-center absolute top-0 left-0 w-full h-full">
            <RedTick />
          </div>
          <div className="w-full h-1/3">
            <RedBg />
          </div>
        </div>
        <div className="text-lg  pt-5 text-center px-16">
          Are you Sure Want to delete{" "}
          <span className="font-bold"> {registryDetail.registryName} </span> Registry
        </div>
        <div className="flex justify-center py-4 gap-6">
          <Button
            color={"blue"}
            varient={"secondary"}
            className={"text-white  px-10 py-2 text-lg font-semibold"}
            onClick={handleOnDelete}
          >
            Delete
          </Button>
          <Button
            color={"lightblue"}
            varient={"secondary"}
            className={" text-blue-800 px-10  py-2 text-lg font-semibold"}
            // onClick={handleCancel}
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default DeleteRegistryConfirmation;
